//存货管理路由
export default [{
  path: 'collectRegister',
  name: 'collectRegister',
  component: function component() {
    return import('@/views/stockManagement/collectEnterManagement/add');
  }
}, {
  path: 'collectRecordList',
  name: 'collectRecordList',
  component: function component() {
    return import('@/views/stockManagement/collectEnterManagement/list');
  }
}, {
  path: 'collectRecordDetail',
  name: 'collectRecordDetail',
  component: function component() {
    return import('@/views/stockManagement/collectEnterManagement/detail');
  }
}, {
  path: 'receiveRegister',
  name: 'receiveRegister',
  component: function component() {
    return import('@/views/stockManagement/receiveOutManagement/add');
  }
}, {
  path: 'receiveRecordList',
  name: 'receiveRecordList',
  component: function component() {
    return import('@/views/stockManagement/receiveOutManagement/list');
  }
}, {
  path: 'receiveRecordDetail',
  name: 'receiveRecordDetail',
  component: function component() {
    return import('@/views/stockManagement/receiveOutManagement/detail');
  }
}, {
  path: 'receiveOutLedgerManagement',
  name: 'receiveOutLedgerManagement',
  component: function component() {
    return import('@/views/stockManagement/receiveOutLedgerManagement/list');
  }
}, {
  path: 'inLedgerManagement',
  name: 'inLedgerManagement',
  component: function component() {
    return import('@/views/stockManagement/receiveOutLedgerManagement/inList');
  }
}, {
  path: 'outLedgerManagement',
  name: 'outLedgerManagement',
  component: function component() {
    return import('@/views/stockManagement/receiveOutLedgerManagement/outList');
  }
}, {
  path: 'usePositionList',
  name: 'usePositionList',
  component: function component() {
    return import('@/views/stockManagement/receiveOutManagement/useList');
  }
}, {
  path: 'InStorageRegister',
  name: 'InStorageRegister',
  component: function component() {
    return import('@/views/stockManagement/inOutStorageManagement/inStorageManagement/add');
  }
}, {
  path: 'AllotInStorageDetail',
  name: 'AllotInStorageDetail',
  component: function component() {
    return import('@/views/stockManagement/inOutStorageManagement/inStorageManagement/allot_detail');
  }
}, {
  path: 'InStorageRecordDetailList',
  name: 'InStorageRecordDetailList',
  component: function component() {
    return import('@/views/stockManagement/inOutStorageManagement/inStorageManagement/list');
  }
}, {
  path: 'jgInStorageRecordDetailList',
  name: 'jgInStorageRecordDetailList',
  component: function component() {
    return import('@/views/stockManagement/inOutStorageManagement/inStorageManagement/JG/list');
  }
}, {
  path: 'pyInStorageRecordDetailList',
  name: 'pyInStorageRecordDetailList',
  component: function component() {
    return import('@/views/stockManagement/inOutStorageManagement/inStorageManagement/PY/list');
  }
}, {
  path: 'wtjgInStorageRecordDetailList',
  name: 'wtjgInStorageRecordDetailList',
  component: function component() {
    return import('@/views/stockManagement/inOutStorageManagement/inStorageManagement/WTJG/list');
  }
}, {
  path: 'AllotInStorageEdit',
  name: 'AllotInStorageEdit',
  component: function component() {
    return import('@/views/stockManagement/inOutStorageManagement/inStorageManagement/allot_add');
  }
}, {
  path: 'AllotInStorageSuccess',
  name: 'AllotInStorageSuccess',
  component: function component() {
    return import('@/views/stockManagement/inOutStorageManagement/inStorageManagement/success');
  }
}, {
  path: 'AllotInStorageBill',
  name: 'AllotInStorageBill',
  component: function component() {
    return import('@/views/stockManagement/inOutStorageManagement/inStorageManagement/allot_list');
  }
}, {
  path: 'InStorageRecordDetail',
  name: 'InStorageRecordDetail',
  component: function component() {
    return import('@/views/stockManagement/inOutStorageManagement/inStorageManagement/detail');
  }
}, {
  path: 'OutStorageRecordRegister',
  name: 'OutStorageRecordRegister',
  component: function component() {
    return import('@/views/stockManagement/outStorageRecordManagement/add');
  }
}, {
  path: 'OutStorageRecordDetailList',
  name: 'OutStorageRecordDetailList',
  component: function component() {
    return import('@/views/stockManagement/outStorageRecordManagement/list');
  }
}, {
  path: 'OutStorageRecordDetail',
  name: 'OutStorageRecordDetail',
  component: function component() {
    return import('@/views/stockManagement/outStorageRecordManagement/detail');
  }
}, {
  path: 'outStorageRecordSuccess',
  name: 'outStorageRecordSuccess',
  component: function component() {
    return import('@/views/stockManagement/outStorageRecordManagement/success');
  }
}, {
  path: 'editResearchProjectOutBill',
  name: 'editResearchProjectOutBill',
  component: function component() {
    return import('@/views/stockManagement/researchProjectOutManagement/add');
  }
}, {
  path: 'researchProjectOutRecordList',
  name: 'researchProjectOutRecordList',
  component: function component() {
    return import('@/views/stockManagement/researchProjectOutManagement/list');
  }
}, {
  path: 'researchProjectOutRecordDetail',
  name: 'researchProjectOutRecordDetail',
  component: function component() {
    return import('@/views/stockManagement/researchProjectOutManagement/detail');
  }
}, {
  path: 'researchProjectOutSuccess',
  name: 'researchProjectOutSuccess',
  component: function component() {
    return import('@/views/stockManagement/researchProjectOutManagement/success');
  }
}, {
  path: 'allotOutRecordDetailList',
  name: 'allotOutRecordDetailList',
  component: function component() {
    return import('@/views/stockManagement/allotOutManagement/list');
  }
}, {
  path: 'allotOutSuccess',
  name: 'allotOutSuccess',
  component: function component() {
    return import('@/views/stockManagement/allotOutManagement/success');
  }
}, {
  path: 'editAllotOutBill',
  name: 'editAllotOutBill',
  component: function component() {
    return import('@/views/stockManagement/allotOutManagement/add');
  }
}, {
  path: 'allotOutBillDetail',
  name: 'allotOutBillDetail',
  component: function component() {
    return import('@/views/stockManagement/allotOutManagement/detail');
  }
}, {
  path: 'inOutLedgerManagementList',
  name: 'inOutLedgerManagementList',
  component: function component() {
    return import('@/views/stockManagement/InOutLedgerManagement/list');
  }
}, {
  path: 'inOutLedgerNewManagementList',
  name: 'inOutLedgerNewManagementList',
  component: function component() {
    return import('@/views/stockManagement/InOutLedgerManagement/newList');
  }
},
// {//物资材料动态表
// 	path: 'materialTrendsList',
// 	name: 'materialTrendsList',
// 	component: () => import('@/views/materialStatisticsManage/trendsList')
// },
{
  //项目经营活动分析表附表
  path: 'operateAnalysisForm',
  name: 'operateAnalysisForm',
  component: function component() {
    return import('@/views/materialStatisticsManage/operateAnalysis');
  }
}, {
  //物资库存明细表
  path: 'materialDetailList',
  name: 'materialDetailList',
  component: function component() {
    return import('@/views/materialStatisticsManage/detailList');
  }
}, {
  //物资材料收发存统计表
  path: 'sendingReceivingStoring',
  name: 'sendingReceivingStoring',
  component: function component() {
    return import('@/views/materialStatisticsManage/sendingReceivingStoringList');
  }
}, {
  //主要材料收发存情况统计表
  path: 'sendingReceivingStoringv2',
  name: 'sendingReceivingStoringv2',
  component: function component() {
    return import('@/views/materialStatisticsManage/setOfTable/sendingReceivingStoring');
  }
}, {
  //主要材料消耗情况对比分析表
  path: 'consumeList',
  name: 'consumeList',
  component: function component() {
    return import('@/views/materialStatisticsManage/setOfTable/consumeList');
  }
}, {
  //单位工程（分部工程）主要材料消耗情况对比分析表
  path: 'partconsume',
  name: 'partconsume',
  component: function component() {
    return import('@/views/materialStatisticsManage/setOfTable/partconsume');
  }
}, {
  //分包队伍主要材料消耗情况对比分析表
  path: 'subpackage',
  name: 'subpackage',
  component: function component() {
    return import('@/views/materialStatisticsManage/setOfTable/subpackage');
  }
}, {
  //发生未入账材料费用统计表
  path: 'notRecorded',
  name: 'notRecorded',
  component: function component() {
    return import('@/views/materialStatisticsManage/setOfTable/notRecorded');
  }
}, {
  path: 'materialFileManageList',
  name: 'materialFileManageList',
  component: function component() {
    return import('@/views/stockManagement/materialFileManage/list');
  }
}, {
  path: 'inLedgerManagementList',
  name: 'inLedgerManagementList',
  component: function component() {
    return import('@/views/stockManagement/InOutLedgerManagement/inList');
  }
}, {
  path: 'outLedgerManagementList',
  name: 'outLedgerManagementList',
  component: function component() {
    return import('@/views/stockManagement/InOutLedgerManagement/outList');
  }
}, {
  path: 'materialStockAmortizationPlanList',
  name: 'materialStockAmortizationPlanList',
  component: function component() {
    return import('@/views/stockManagement/amortizationManagement/planList');
  }
}, {
  path: 'turnoverMaterialUseList',
  name: 'turnoverMaterialUseList',
  component: function component() {
    return import('@/views/stockManagement/turnoverMaterialUse/list');
  }
}, {
  path: 'turnoverMaterialUseEdit',
  name: 'turnoverMaterialUseEdit',
  component: function component() {
    return import('@/views/stockManagement/turnoverMaterialUse/edit');
  }
}, {
  path: 'turnoverMaterialUseDetail',
  name: 'turnoverMaterialUseDetail',
  component: function component() {
    return import('@/views/stockManagement/turnoverMaterialUse/detail');
  }
}, {
  path: 'turnoverMaterialUseSuccess',
  name: 'turnoverMaterialUseSuccess',
  component: function component() {
    return import('@/views/stockManagement/turnoverMaterialUse/success');
  }
}, {
  path: 'turnoverMaterialList',
  name: 'turnoverMaterialList',
  component: function component() {
    return import('@/views/stockManagement/turnoverMaterial/list');
  }
}, {
  path: 'materialStockOutBuildingZZApplicationEdit',
  name: 'materialStockOutBuildingZZApplicationEdit',
  component: function component() {
    return import('@/views/stockManagement/turnoverMaterial/edit');
  }
}, {
  path: 'turnoverMaterialDetail',
  name: 'turnoverMaterialDetail',
  component: function component() {
    return import('@/views/stockManagement/turnoverMaterial/detail');
  }
}, {
  path: 'materialStockZZAmortizationList',
  name: 'materialStockZZAmortizationList',
  component: function component() {
    return import('@/views/stockManagement/turnoverMaterialExit/list');
  }
}, {
  path: 'materialStockZZAmortizationEdit',
  name: 'materialStockZZAmortizationEdit',
  component: function component() {
    return import('@/views/stockManagement/turnoverMaterialExit/add');
  }
},
//materialStockZZAmortizationDetail
{
  path: 'materialStockZZAmortizationDetail',
  name: 'materialStockZZAmortizationDetail',
  component: function component() {
    return import('@/views/stockManagement/turnoverMaterialExit/detail');
  }
}, {
  path: 'materialStockZZAmortizationSuccess',
  name: 'materialStockZZAmortizationSuccess',
  component: function component() {
    return import('@/views/stockManagement/turnoverMaterialExit/success');
  }
}, {
  path: 'materialStockAmortizationPlanEdit',
  name: 'materialStockAmortizationPlanEdit',
  component: function component() {
    return import('@/views/stockManagement/amortizationManagement/add');
  }
}, {
  path: 'amortizationUpdate',
  name: 'amortizationUpdate',
  component: function component() {
    return import('@/views/stockManagement/amortizationManagement/update');
  }
}, {
  path: 'materialStockAmortizationPlanDetail',
  name: 'materialStockAmortizationPlanDetail',
  component: function component() {
    return import('@/views/stockManagement/amortizationManagement/detail');
  }
}, {
  path: 'amortizationLedger',
  name: 'amortizationLedger',
  component: function component() {
    return import('@/views/stockManagement/amortizationManagement/ledger');
  }
}, {
  path: 'amortizationSuccess',
  name: 'amortizationSuccess',
  component: function component() {
    return import('@/views/stockManagement/amortizationManagement/success');
  }
}, {
  path: 'materialTrendsList',
  name: 'materialTrendsList',
  component: function component() {
    return import('@/views/stockManagement/tableManagment/trendsTable');
  }
}, {
  path: 'materialAllocationList',
  name: 'materialAllocationList',
  component: function component() {
    return import('@/views/stockManagement/tableManagment/allocationTable');
  }
}, {
  path: 'MaterialList',
  name: 'MaterialList',
  component: function component() {
    return import('@/views/stockManagement/MaterialList/index');
  }
}, {
  path: 'materialDeliveryList',
  name: 'materialDeliveryList',
  component: function component() {
    return import('@/views/stockManagement/MaterialList/deliveryList');
  }
}, {
  path: 'materialDeliveryEdit',
  name: 'materialDeliveryEdit',
  component: function component() {
    return import('@/views/stockManagement/MaterialList/deliveryEdit');
  }
}, {
  path: 'materialDeliveryDetail',
  name: 'materialDeliveryDetail',
  component: function component() {
    return import('@/views/stockManagement/MaterialList/deliveryDetail');
  }
}, {
  path: 'buildingAuthList',
  name: 'buildingAuthList',
  component: function component() {
    return import('@/views/stockManagement/subcontract/list');
  }
}, {
  path: 'buildingAuthDetail',
  name: 'buildingAuthDetail',
  component: function component() {
    return import('@/views/stockManagement/subcontract/detail');
  }
}, {
  path: 'buildingAuthSuccess',
  name: 'buildingAuthSuccess',
  component: function component() {
    return import('@/views/stockManagement/subcontract/success');
  }
}, {
  path: 'materiallContractList',
  name: 'materiallContractList',
  component: function component() {
    return import('@/views/stockManagement/contract/list');
  }
}, {
  path: 'collectiveMateriallContractList',
  name: 'collectiveMateriallContractList',
  component: function component() {
    return import('@/views/stockManagement/contract/collectiveList');
  }
}, {
  path: 'supplementMateriallContractList',
  name: 'supplementMateriallContractList',
  component: function component() {
    return import('@/views/stockManagement/contract/supplementList');
  }
}, {
  path: 'supplementMateriallContractDetail',
  name: 'supplementMateriallContractDetail',
  component: function component() {
    return import('@/views/stockManagement/contract/supplementDetail');
  }
}, {
  path: 'supplementContractEdit',
  name: 'supplementContractEdit',
  component: function component() {
    return import('@/views/stockManagement/contract/supplementEdit');
  }
}, {
  path: 'collectiveContractEdit',
  name: 'collectiveContractEdit',
  component: function component() {
    return import('@/views/stockManagement/contract/edit');
  }
}, {
  path: 'collectiveContractDetail',
  name: 'collectiveContractDetail',
  component: function component() {
    return import('@/views/stockManagement/contract/detail');
  }
}, {
  path: 'collectiveContractSuccess',
  name: 'collectiveContractSuccess',
  component: function component() {
    return import('@/views/stockManagement/contract/success');
  }
}, {
  path: 'materialVerificationList',
  name: 'materialVerificationList',
  component: function component() {
    return import('@/views/stockManagement/verification/list');
  }
}, {
  path: 'verifyOwnerEdit',
  name: 'verifyOwnerEdit',
  component: function component() {
    return import('@/views/stockManagement/verification/subcontracting/edit');
  }
}, {
  path: 'verifyOwnerList',
  name: 'verifyOwnerList',
  component: function component() {
    return import('@/views/stockManagement/verification/subcontracting/list');
  }
}, {
  path: 'verifyOwnerDetail',
  name: 'verifyOwnerDetail',
  component: function component() {
    return import('@/views/stockManagement/verification/subcontracting/detail');
  }
}, {
  path: 'verifyOwnerSuccess',
  name: 'verifyOwnerSuccess',
  component: function component() {
    return import('@/views/stockManagement/verification/subcontracting/success');
  }
}, {
  path: 'verifyBulkEdit',
  name: 'verifyBulkEdit',
  component: function component() {
    return import('@/views/stockManagement/verification/bulk/edit');
  }
}, {
  path: 'verifyBulkList',
  name: 'verifyBulkList',
  component: function component() {
    return import('@/views/stockManagement/verification/bulk/list');
  }
}, {
  path: 'verifyBulkDetail',
  name: 'verifyBulkDetail',
  component: function component() {
    return import('@/views/stockManagement/verification/bulk/detail');
  }
}, {
  path: 'verifyBulkSuccess',
  name: 'verifyBulkSuccess',
  component: function component() {
    return import('@/views/stockManagement/verification/bulk/success');
  }
}, {
  path: 'quantityDynamicManagement',
  name: 'quantityDynamicManagement',
  component: function component() {
    return import('@/views/stockManagement/quantityDynamicManagement/list');
  }
}, {
  path: 'projectQuantityDynamicEdit',
  name: 'projectQuantityDynamicEdit',
  component: function component() {
    return import('@/views/stockManagement/quantityDynamicManagement/dynamic/edit');
  }
}, {
  path: 'projectQuantityDynamicDetail',
  name: 'projectQuantityDynamicDetail',
  component: function component() {
    return import('@/views/stockManagement/quantityDynamicManagement/dynamic/detail');
  }
}, {
  path: 'projectQuantityDynamicUpdate',
  name: 'projectQuantityDynamicUpdate',
  component: function component() {
    return import('@/views/stockManagement/quantityDynamicManagement/dynamic/update');
  }
}, {
  path: 'quantityDynamicSuccess',
  name: 'quantityDynamicSuccess',
  component: function component() {
    return import('@/views/stockManagement/quantityDynamicManagement/dynamic/success');
  }
}, {
  path: 'projectNetUsageEdit',
  name: 'projectNetUsageEdit',
  component: function component() {
    return import('@/views/stockManagement/quantityDynamicManagement/netUsage/edit');
  }
}, {
  path: 'projectNetUsageDetail',
  name: 'projectNetUsageDetail',
  component: function component() {
    return import('@/views/stockManagement/quantityDynamicManagement/netUsage/detail');
  }
}, {
  path: 'projectNetUsageSuccess',
  name: 'projectNetUsageSuccess',
  component: function component() {
    return import('@/views/stockManagement/quantityDynamicManagement/netUsage/success');
  }
}, {
  path: 'projectConcreteEdit',
  name: 'projectConcreteEdit',
  component: function component() {
    return import('@/views/stockManagement/quantityDynamicManagement/concrete/edit');
  }
}, {
  path: 'projectConcreteDetail',
  name: 'projectConcreteDetail',
  component: function component() {
    return import('@/views/stockManagement/quantityDynamicManagement/concrete/detail');
  }
}, {
  path: 'projectConcreteSuccess',
  name: 'projectConcreteSuccess',
  component: function component() {
    return import('@/views/stockManagement/quantityDynamicManagement/concrete/success');
  }
}, {
  path: 'projectConcreteList',
  name: 'projectConcreteList',
  component: function component() {
    return import('@/views/stockManagement/quantityDynamicManagement/concrete/list');
  }
}, {
  path: 'projectQuantityEdit',
  name: 'projectQuantityEdit',
  component: function component() {
    return import('@/views/stockManagement/quantityDynamicManagement/quantity/edit');
  }
}, {
  path: 'concreteTheorUsageCheckDetail',
  name: 'concreteTheorUsageCheckDetail',
  component: function component() {
    return import('@/views/stockManagement/quantityDynamicManagement/quantity/detail');
  }
}, {
  path: 'concreteTheorUsageCheckSuccess',
  name: 'concreteTheorUsageCheckSuccess',
  component: function component() {
    return import('@/views/stockManagement/quantityDynamicManagement/quantity/success');
  }
}, {
  path: 'settlementVolumManagement',
  name: 'settlementVolumManagement',
  component: function component() {
    return import('@/views/stockManagement/settlementVolumManagement/list');
  }
}, {
  path: 'MaterialProjectBuildingDesignNetUsageEdit',
  name: 'MaterialProjectBuildingDesignNetUsageEdit',
  component: function component() {
    return import('@/views/stockManagement/settlementVolumManagement/netConsumption/temp');
  }
}, {
  path: 'MaterialProjectBuildingDesignNetUsageDetail',
  name: 'MaterialProjectBuildingDesignNetUsageDetail',
  component: function component() {
    return import('@/views/stockManagement/settlementVolumManagement/netConsumption/detail');
  }
}, {
  path: 'settlementVolumSuccess',
  name: 'settlementVolumSuccess',
  component: function component() {
    return import('@/views/stockManagement/settlementVolumManagement/netConsumption/success');
  }
}, {
  path: 'settlementVolumQuantityTemp',
  name: 'settlementVolumQuantityTemp',
  component: function component() {
    return import('@/views/stockManagement/settlementVolumManagement/quantity/temp');
  }
}, {
  path: 'materialProjectBuildingPeriodCheckEdit',
  name: 'materialProjectBuildingPeriodCheckEdit',
  component: function component() {
    return import('@/views/stockManagement/settlementVolumManagement/quantity/edit');
  }
}, {
  path: 'materialProjectBuildingPeriodCheckDetail',
  name: 'materialProjectBuildingPeriodCheckDetail',
  component: function component() {
    return import('@/views/stockManagement/settlementVolumManagement/quantity/detail');
  }
}, {
  path: 'settlementVolumQuantitySuccess',
  name: 'settlementVolumQuantitySuccess',
  component: function component() {
    return import('@/views/stockManagement/settlementVolumManagement/quantity/success');
  }
}, {
  path: 'settlementVolumQuantityRejectSuccess',
  name: 'settlementVolumQuantityRejectSuccess',
  component: function component() {
    return import('@/views/stockManagement/settlementVolumManagement/quantity/rejectSuccess');
  }
}, {
  path: 'materialProjectManagement',
  name: 'materialProjectManagement',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/index');
  }
}, {
  path: 'materialProjectSuccess',
  name: 'materialProjectSuccess',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/success');
  }
}, {
  path: 'materialProjectBuildingStockCheckEdit',
  name: 'materialProjectBuildingStockCheckEdit',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/stockCheck/edit');
  }
}, {
  path: 'materialProjectBuildingStockCheckList',
  name: 'materialProjectBuildingStockCheckList',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/stockCheck/list');
  }
}, {
  path: 'materialProjectBuildingStockCheckDetail',
  name: 'materialProjectBuildingStockCheckDetail',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/stockCheck/detail');
  }
}, {
  path: 'materialProjectBuildingStockCheckSummaryEdit',
  name: 'materialProjectBuildingStockCheckSummaryEdit',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/stockCheckSummary/edit');
  }
}, {
  path: 'materialProjectBuildingStockCheckSummaryList',
  name: 'materialProjectBuildingStockCheckSummaryList',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/stockCheckSummary/list');
  }
}, {
  path: 'materialProjectBuildingStockCheckSummaryDetail',
  name: 'materialProjectBuildingStockCheckSummaryDetail',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/stockCheckSummary/detail');
  }
}, {
  path: 'materialProjectBuildingPeriodUsageEdit',
  name: 'materialProjectBuildingPeriodUsageEdit',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/periodUsage/edit');
  }
}, {
  path: 'materialProjectBuildingPeriodUsageDetail',
  name: 'materialProjectBuildingPeriodUsageDetail',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/periodUsage/detail');
  }
}, {
  path: 'materialProjectBuildingPeriodUsageSummaryEdit',
  name: 'materialProjectBuildingPeriodUsageSummaryEdit',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/periodUsageSummary/edit');
  }
}, {
  path: 'materialProjectBuildingPeriodUsageSummaryDetail',
  name: 'materialProjectBuildingPeriodUsageSummaryDetail',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/periodUsageSummary/detail');
  }
}, {
  path: 'materialProjectBuildingPriceGatherEdit',
  name: 'materialProjectBuildingPriceGatherEdit',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/priceGather/edit');
  }
}, {
  path: 'materialProjectBuildingPriceGatherDetail',
  name: 'materialProjectBuildingPriceGatherDetail',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/priceGather/detail');
  }
}, {
  path: 'materialVerificationReport',
  name: 'materialVerificationReport',
  component: function component() {
    return import('@/views/stockManagement/materialVerificationReport/index');
  }
}, {
  path: 'materialProjectBuildingPeriodCheckSummaryEdit',
  name: 'materialProjectBuildingPeriodCheckSummaryEdit',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/periodCheckSummary/edit');
  }
}, {
  path: 'materialProjectBuildingPeriodCheckSummaryDetail',
  name: 'materialProjectBuildingPeriodCheckSummaryDetail',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/periodCheckSummary/detail');
  }
}, {
  path: 'materialProjectBuildingPeriodOverCostEdit',
  name: 'materialProjectBuildingPeriodOverCostEdit',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/periodOverCost/edit');
  }
}, {
  path: 'materialProjectBuildingPeriodOverCostDetail',
  name: 'materialProjectBuildingPeriodOverCostDetail',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/periodOverCost/detail');
  }
}, {
  path: 'materialProjectBuildingPeriodOverCostSolveEdit',
  name: 'materialProjectBuildingPeriodOverCostSolveEdit',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/periodOverCostSolve/edit');
  }
}, {
  path: 'materialProjectBuildingPeriodOverCostSolveDetail',
  name: 'materialProjectBuildingPeriodOverCostSolveDetail',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/periodOverCostSolve/detail');
  }
}, {
  path: 'materialProjectBuildingCheckSummaryEdit',
  name: 'materialProjectBuildingCheckSummaryEdit',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/checkSummary/edit');
  }
}, {
  path: 'materialProjectBuildingCheckSummaryDetail',
  name: 'materialProjectBuildingCheckSummaryDetail',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/checkSummary/detail');
  }
}, {
  path: 'materialProjectBuildingOverCostSummaryEdit',
  name: 'materialProjectBuildingOverCostSummaryEdit',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/overCostSummary/edit');
  }
}, {
  path: 'materialProjectBuildingOverCostSummaryDetail',
  name: 'materialProjectBuildingOverCostSummaryDetail',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/overCostSummary/detail');
  }
}, {
  path: 'materialProjectBuildingCheckEdit',
  name: 'materialProjectBuildingCheckEdit',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/check/edit');
  }
}, {
  path: 'materialProjectBuildingCheckDetail',
  name: 'materialProjectBuildingCheckDetail',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/building/check/detail');
  }
}, {
  path: 'buyerOrderNotice',
  name: 'buyerOrderNotice',
  component: function component() {
    return import('@/views/stockManagement/supplyDemandOrderManage/buyerOrderNotice/list');
  }
}, {
  path: 'supplierDeliveryList',
  name: 'supplierDeliveryList',
  component: function component() {
    return import('@/views/stockManagement/supplyDemandOrderManage/supplierDeliveryList/list');
  }
}, {
  path: 'supplierDeliveryAdd',
  name: 'supplierDeliveryAdd',
  component: function component() {
    return import('@/views/stockManagement/supplyDemandOrderManage/supplierDeliveryList/add');
  }
}, {
  path: 'supplierDeliveryDetail',
  name: 'supplierDeliveryDetail',
  component: function component() {
    return import('@/views/stockManagement/supplyDemandOrderManage/supplierDeliveryList/detail');
  }
}, {
  path: 'supplierExecutionLedger',
  name: 'supplierExecutionLedger',
  component: function component() {
    return import('@/views/stockManagement/supplyDemandOrderManage/supplierExecutionLedger/list');
  }
}, {
  path: 'materialDeliveryReceiptEdit',
  name: 'materialDeliveryReceiptEdit',
  component: function component() {
    return import('@/views/stockManagement/MaterialList/deliveryReceiptEdit');
  }
}, {
  path: 'materialDeliveryReceiptDetail',
  name: 'materialDeliveryReceiptDetail',
  component: function component() {
    return import('@/views/stockManagement/MaterialList/deliveryReceiptDetail');
  }
}, {
  path: 'materialStockOutBuildingApplicationList',
  name: 'materialStockOutBuildingApplicationList',
  component: function component() {
    return import('@/views/stockManagement/outBuildingApplicationManagement/list');
  }
}, {
  path: 'materialStockOutBuildingApplicationEdit',
  name: 'materialStockOutBuildingApplicationEdit',
  component: function component() {
    return import('@/views/stockManagement/outBuildingApplicationManagement/edit');
  }
}, {
  path: 'materialStockOutBuildingApplicationDetail',
  name: 'materialStockOutBuildingApplicationDetail',
  component: function component() {
    return import('@/views/stockManagement/outBuildingApplicationManagement/detail');
  }
}, {
  path: 'materialInSignEdit',
  name: 'materialInSignEdit',
  component: function component() {
    return import('@/views/stockManagement/materialInSignManagement/edit');
  }
}, {
  path: 'materialInSignDetail',
  name: 'materialInSignDetail',
  component: function component() {
    return import('@/views/stockManagement/materialInSignManagement/detail');
  }
}, {
  path: 'turnoverMaterialDistribution',
  name: 'turnoverMaterialDistribution',
  component: function component() {
    return import('@/views/stockManagement/turnoverMaterialDistribution/index');
  }
}, {
  path: 'turnoverMaterialDistributionDetail',
  name: 'turnoverMaterialDistributionDetail',
  component: function component() {
    return import('@/views/stockManagement/turnoverMaterialDistribution/detail');
  }
}, {
  path: 'turnoverMaterialAmortization',
  name: 'turnoverMaterialAmortization',
  component: function component() {
    return import('@/views/stockManagement/turnoverMaterialAmortization/index');
  }
}, {
  path: 'materialProjectSafeControlList',
  name: 'materialProjectSafeControlList',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/safe/list');
  }
}, {
  path: 'materialProjectSafeControlEdit',
  name: 'materialProjectSafeControlEdit',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/safe/edit');
  }
}, {
  path: 'materialProjectSafeControlDetail',
  name: 'materialProjectSafeControlDetail',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/safe/detail');
  }
}, {
  path: 'materialProjectSmallVehicleInspectionList',
  name: 'materialProjectSmallVehicleInspectionList',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/inspection/smallVehicleEnter/list');
  }
}, {
  path: 'materialProjectSmallVehicleInspectionEdit',
  name: 'materialProjectSmallVehicleInspectionEdit',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/inspection/smallVehicleEnter/edit');
  }
}, {
  path: 'materialProjectSmallVehicleInspectionDetail',
  name: 'materialProjectSmallVehicleInspectionDetail',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/inspection/smallVehicleEnter/detail');
  }
}, {
  path: 'materialProjectVehicleEnterInspectList',
  name: 'materialProjectVehicleEnterInspectList',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/inspection/vehicleEnter/list');
  }
}, {
  path: 'materialProjectVehicleEnterInspectEdit',
  name: 'materialProjectVehicleEnterInspectEdit',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/inspection/vehicleEnter/edit');
  }
}, {
  path: 'materialProjectVehicleEnterInspectDetail',
  name: 'materialProjectVehicleEnterInspectDetail',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/inspection/vehicleEnter/detail');
  }
}, {
  path: 'materialProjectMaterialEnterInspectList',
  name: 'materialProjectMaterialEnterInspectList',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/inspection/materialEnter/list');
  }
}, {
  path: 'materialProjectMaterialEnterInspectEdit',
  name: 'materialProjectMaterialEnterInspectEdit',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/inspection/materialEnter/edit');
  }
}, {
  path: 'materialProjectMaterialEnterInspectDetail',
  name: 'materialProjectMaterialEnterInspectDetail',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/inspection/materialEnter/detail');
  }
}, {
  path: 'materialInspectionLedger',
  name: 'materialInspectionLedger',
  component: function component() {
    return import('@/views/stockManagement/qualityManagement/inspection/list');
  }
}, {
  path: 'stockInExamineEdit',
  name: 'stockInExamineEdit',
  component: function component() {
    return import('@/views/stockManagement/qualityManagement/inspection/edit');
  }
}, {
  path: 'stockInExamineDetail',
  name: 'stockInExamineDetail',
  component: function component() {
    return import('@/views/stockManagement/qualityManagement/inspection/detail');
  }
}, {
  path: 'materialInspectionSuccess',
  name: 'materialInspectionSuccess',
  component: function component() {
    return import('@/views/stockManagement/qualityManagement/inspection/success');
  }
}, {
  path: 'materialUnqualifiedLedger',
  name: 'materialUnqualifiedLedger',
  component: function component() {
    return import('@/views/stockManagement/qualityManagement/unqualified/list');
  }
}, {
  path: 'stockInExamineUnqualifiedEdit',
  name: 'stockInExamineUnqualifiedEdit',
  component: function component() {
    return import('@/views/stockManagement/qualityManagement/unqualified/edit');
  }
}, {
  path: 'stockInExamineUnqualifiedDetail',
  name: 'stockInExamineUnqualifiedDetail',
  component: function component() {
    return import('@/views/stockManagement/qualityManagement/unqualified/detail');
  }
}, {
  path: 'materialUnqualifiedSuccess',
  name: 'materialUnqualifiedSuccess',
  component: function component() {
    return import('@/views/stockManagement/qualityManagement/unqualified/success');
  }
}, {
  path: 'materialEnterApprovalLedger',
  name: 'materialEnterApprovalLedger',
  component: function component() {
    return import('@/views/stockManagement/qualityManagement/enterApproval/list');
  }
}, {
  path: 'materialEnterApprovalEdit',
  name: 'materialEnterApprovalEdit',
  component: function component() {
    return import('@/views/stockManagement/qualityManagement/enterApproval/edit');
  }
}, {
  path: 'materialEnterApprovalDetail',
  name: 'materialEnterApprovalDetail',
  component: function component() {
    return import('@/views/stockManagement/qualityManagement/enterApproval/detail');
  }
}, {
  path: 'materialEnterApprovalSuccess',
  name: 'materialEnterApprovalSuccess',
  component: function component() {
    return import('@/views/stockManagement/qualityManagement/enterApproval/success');
  }
}, {
  path: 'materialProjectSafetyCheckList',
  name: 'materialProjectSafetyCheckList',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/safetyCheck/list');
  }
}, {
  path: 'stockSafeCheckSGWZEdit',
  name: 'stockSafeCheckSGWZEdit',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/stockSafeCheck/sgwz/edit');
  }
}, {
  path: 'stockSafeCheckSGWZDetail',
  name: 'stockSafeCheckSGWZDetail',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/stockSafeCheck/sgwz/detail');
  }
}, {
  path: 'stockSafeCheckSGJJEdit',
  name: 'stockSafeCheckSGJJEdit',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/stockSafeCheck/sgjj/edit');
  }
}, {
  path: 'stockSafeCheckSGJJDetail',
  name: 'stockSafeCheckSGJJDetail',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/stockSafeCheck/sgjj/detail');
  }
}, {
  path: 'stockSafeRectificationEdit',
  name: 'stockSafeRectificationEdit',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/stockSafeRectification/edit');
  }
}, {
  path: 'stockSafeRectificationDetail',
  name: 'stockSafeRectificationDetail',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/stockSafeRectification/detail');
  }
}, {
  path: 'stockSafeRectificationReceiptEdit',
  name: 'stockSafeRectificationReceiptEdit',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/stockSafeRectificationReceipt/edit');
  }
}, {
  path: 'stockSafeRectificationReceiptDetail',
  name: 'stockSafeRectificationReceiptDetail',
  component: function component() {
    return import('@/views/stockManagement/materialProjectManage/stockSafeRectificationReceipt/detail');
  }
}, {
  path: 'materialStockReportCarFuelList',
  name: 'materialStockReportCarFuelList',
  component: function component() {
    return import('@/views/stockManagement/materialStockReportCarFuelManage/list');
  }
}, {
  path: 'stockOutCarFuelList',
  name: 'stockOutCarFuelList',
  component: function component() {
    return import('@/views/stockManagement/stockOutCarFuelManage/list');
  }
}, {
  path: 'stockOutCarFuelEdit',
  name: 'stockOutCarFuelEdit',
  component: function component() {
    return import('@/views/stockManagement/stockOutCarFuelManage/edit');
  }
}, {
  path: 'stockOutCarFuelDetail',
  name: 'stockOutCarFuelDetail',
  component: function component() {
    return import('@/views/stockManagement/stockOutCarFuelManage/detail');
  }
}, {
  path: 'stockCarList',
  name: 'stockCarList',
  component: function component() {
    return import('@/views/stockManagement/stockCarManage/list');
  }
}, {
  path: 'stockOutCarFuelItemList',
  name: 'stockOutCarFuelItemList',
  component: function component() {
    return import('@/views/stockManagement/stockOutCarFuelItemManage/list');
  }
}];